import { z } from 'zod'
import typeguard from '../typeguard'
import { magazineOverviewDataSchema, magazineSchema } from '../dbTypes/magazine'
import { productsPreviewSchema } from '../frontendTypes/product'
import { landingPageImageAiGeneratedSchema } from './landingPageSettings'

const magazineResponseSchema = magazineSchema.extend({
  onlineFrom: z.string().optional(),
  onlineTo: z.string().optional(),
  created: z.string(),
  changed: z.string(),
})
export type magazineResponse = z.infer<typeof magazineResponseSchema>
export const isMagazineResponse = typeguard<magazineResponse>(magazineResponseSchema)

export const publicMagazineSummarySchema = z.object({
  id: z.number(),
  title: z.string(),
  slug: z.string(),
  href: z.string().optional(),
  issue: z.string().optional(),
  subtitle: z.string().optional(),
  excerpt: z.string().optional(),
  coverImage: magazineResponseSchema.shape.coverImage,
  mode: magazineResponseSchema.shape.mode,
  tags: magazineResponseSchema.shape.tags,
  date: z.string().optional(),
  pagesCount: z.number(),
})
export type publicMagazineSummary = z.infer<typeof publicMagazineSummarySchema>

export const publicMagazinesResponseSchema = z.object({
  overview: magazineOverviewDataSchema.optional(),
  magazines: z.array(publicMagazineSummarySchema),
  landingPageImageAiGenerated: landingPageImageAiGeneratedSchema.optional(),
})
export type publicMagazinesResponse = z.infer<typeof publicMagazinesResponseSchema>
export const isPublicMagazinesResponse = typeguard<publicMagazinesResponse>(publicMagazinesResponseSchema)

export const publicMagazineResponseSchema = magazineResponseSchema.extend({
  href: z.string().optional(),
  products: productsPreviewSchema,
  landingPageImageAiGenerated: landingPageImageAiGeneratedSchema.optional(),
})
export type publicMagazineResponse = z.infer<typeof publicMagazineResponseSchema>
export const isPublicMagazineResponse = typeguard<publicMagazineResponse>(publicMagazineResponseSchema)
